/*
 * MDB shim for MDBModalFooter
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 */

import MUIDialogActions from "@mui/material/DialogActions";

export default function MDBModalFooter({ children, ...rest }) {
    return <MUIDialogActions {...rest}>{children}</MUIDialogActions>;
}
